'use strict';

var GetIntrinsic$1 = require('../GetIntrinsic.js');
require('./callBind.js');
var callBind$1 = require('../../../../../_virtual/callBind.js_commonjs-module.js');

var GetIntrinsic = GetIntrinsic$1;

var $test = GetIntrinsic('RegExp.prototype.test');

var callBind = callBind$1.callBind.exports;

var regexTester = function regexTester(regex) {
	return callBind($test, regex);
};

module.exports = regexTester;
